import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-affiliates',
  templateUrl: './affiliates.component.html',
  styleUrls: ['./affiliates.component.scss']
})
export class AffiliatesComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
    ) { }

  ngOnInit() {
    this.titleService.setTitle('Trinka Affiliate Program | AI-Powered Grammar Check Tool');
    this.metaTagService.updateTag({ name: 'description', content: "Know about Trinka's affiliate program · Want to become an affiliate? How can you promote Trinka? Commissions and remittance options. Product and Affiliate Program features." });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka - 학술 및 기술 글쓰기에 적합한 문법 검사' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka는 학술 및 기술 글쓰기에 적합한 유일한 AI 문법 및 언어 검사 도구입니다. Trinka는 문법 차원을 넘어, 어조, 스타일, 가독성 등 많은 측면에서 귀하의 글을 개선해 출판할 준비를 갖춥니다!' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://trinka.ai/kr/affiliates' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/affiliates' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/affiliates' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/affiliates' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/affiliates'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/affiliates'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/affiliates' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/affiliates' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/affiliates' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/affiliates' });
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
    
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
